import React, { useEffect, useState } from 'react';
import { Wallet, MapPin, Flag, Article, BookmarkSimple, SealCheck, Star, Users, ArrowLeft, PaperPlaneTilt, Check, CaretRight, X } from '@phosphor-icons/react';
import { AuthGateModal, AuthGateIntent } from '../components/marketplace/AuthGateModal';
import { OfferEditModal } from '../components/dashboard/OfferEditModal';
import { HOUSING_TYPES } from '../lib/constants';
import { PAGE_ROUTE } from '../lib/routes';
import { cn, getSession, isBookmarked, toggleBookmark, formatBudget, LIVING_MODE_DISPLAY, LivingModeValue, isFullyVerified, hasAppliedTo, hasOfferTo, getOffersForTenant, comboGroupLabel } from '../lib/utils';
import { AvatarStack } from '../components/ui/AvatarStack';
interface TenantAnuntProps {
  navigate: (page: string, context?: any) => void;
  context?: {
    slug?: string;
    viewerIsOwner?: boolean;
    openApplyModal?: boolean;
  };
}
const MOCK_PROFILES: Record<string, any> = {
  'olivia-p': {
    id: '1',
    slug: 'olivia-p',
    firstName: 'Olivia',
    lastName: 'P.',
    birthYear: 1995,
    occupation: 'Freelancer',
    city: 'București',
    budgetMin: 500,
    budgetMax: 650,
    budgetCurrency: 'EUR',
    housingType: 'apartament_bloc',
    coupleStatus: 'cuplu',
    isSmoker: false,
    hasPets: true,
    petDetails: '1 pisică',
    profilePhoto: 'https://i.pravatar.cc/150?img=5',
    profileViews: 142,
    verifications: {
      email: true,
      identity: true,
      income: true
    },
    rating: 4.8,
    neighborhoods: 'Floreasca, Aviatorilor',
    moveInDate: 'Octombrie, 2026',
    contractDuration: '1 an',
    rooms: '3 cam',
    floor: 'Etaj 1-3',
    yearBuiltLabel: '> 1990',
    profileStatus: 'active',
    amenities: ['Centrală termică', 'Parcare', 'Aer condiționat', 'Mobilat complet', 'Balcon / Terasă', 'Lift', 'Mașină de spălat vase'],
    bio: 'Bună, eu sunt Olivia. Lucrez de acasă ca freelancer și caut un apartament luminos, preferabil cu un spațiu pe care să-l pot amenaja ca birou. Suntem un cuplu liniștit și avem o pisică foarte educată. Ne-ar plăcea un proprietar comunicativ și deschis la o închiriere pe termen lung.',
    reviews: [],
    rentalHistory: []
  },
  'andrei-popescu': {
    id: '2',
    slug: 'andrei-popescu',
    firstName: 'Andrei',
    lastName: 'P.',
    birthYear: 1996,
    occupation: 'Product Designer',
    city: 'București',
    budgetMin: 400,
    budgetMax: 550,
    budgetCurrency: 'EUR',
    housingType: 'apartament_bloc',
    coupleStatus: 'singur',
    isSmoker: false,
    hasPets: false,
    petDetails: '',
    profilePhoto: 'https://i.pravatar.cc/150?img=11',
    profileViews: 142,
    verifications: {
      email: true,
      identity: true,
      income: false
    },
    rating: 4.6,
    neighborhoods: 'Cotroceni, Militari',
    moveInDate: 'Iunie, 2026',
    contractDuration: '2 ani',
    rooms: '2 cam',
    floor: 'Etaj 2-5',
    yearBuiltLabel: '> 2000',
    profileStatus: 'active',
    amenities: ['Centrală termică', 'Mobilat complet', 'Aer condiționat', 'Balcon / Terasă', 'Aproape de metrou'],
    bio: 'Salut! Sunt Andrei, lucrez ca Product Designer. Caut un loc modern și curat, aproape de metrou. Sunt ordonat, nu fumez și plătesc mereu la timp.',
    reviews: [],
    rentalHistory: []
  },
  'maria-ionescu': {
    id: '3',
    slug: 'maria-ionescu',
    firstName: 'Maria',
    lastName: 'I.',
    birthYear: 1992,
    occupation: 'Marketing Manager',
    city: 'Cluj-Napoca',
    budgetMin: 600,
    budgetMax: 800,
    budgetCurrency: 'EUR',
    housingType: 'apartament_bloc',
    coupleStatus: 'cuplu',
    isSmoker: false,
    hasPets: true,
    petDetails: '1 pisică',
    profilePhoto: 'https://i.pravatar.cc/150?img=9',
    profileViews: 89,
    verifications: {
      email: true,
      identity: false,
      income: false
    },
    rating: 4.9,
    neighborhoods: 'Centru, Andrei Mureșanu',
    moveInDate: 'August, 2026',
    contractDuration: '1 an',
    rooms: '3 cam',
    floor: 'Etaj 1-4',
    yearBuiltLabel: '> 1995',
    profileStatus: 'active',
    amenities: ['Centrală termică', 'Parcare', 'Mobilat complet', 'Lift', 'Balcon / Terasă'],
    bio: 'Lucrez în marketing de 8 ani. Împreună cu partenerul meu, căutăm un apartament spațios pe termen lung. Avem o pisică foarte cuminte.',
    reviews: [],
    rentalHistory: []
  },
  // ── Combo / Grup mocks (MVP: invite-only finalized groups) ────────────
  'andrei-combo': {
    id: '9',
    slug: 'andrei-combo',
    firstName: 'Andrei',
    lastName: 'M.',
    birthYear: 1998,
    occupation: 'Software Engineer',
    city: 'București',
    budgetMin: 400,
    budgetMax: 550,
    budgetCurrency: 'EUR',
    housingType: 'apartament_bloc',
    coupleStatus: 'singur',
    isSmoker: false,
    hasPets: false,
    petDetails: '',
    profilePhoto: 'https://i.pravatar.cc/150?img=14',
    profileViews: 64,
    verifications: {
      email: true,
      identity: true,
      income: false
    },
    rating: 4.5,
    neighborhoods: 'Tineretului, Unirii',
    moveInDate: 'August, 2026',
    contractDuration: '1 an',
    rooms: '2 cam',
    floor: 'Etaj 1-5',
    yearBuiltLabel: '> 2000',
    profileStatus: 'active',
    amenities: ['Mobilat complet', 'Lift', 'Aer condiționat'],
    bio: 'Suntem doi prieteni care căutăm un apartament de 2 camere în Tineretului. Amândoi lucrăm remote, suntem ordonați și ne place să stăm acasă.',
    reviews: [],
    rentalHistory: [],
    comboMembers: [{
      name: 'Andrei M.',
      avatar: 'https://i.pravatar.cc/150?img=14',
      slug: 'andrei-combo',
      occupation: 'Software Engineer',
      verified: true,
      rating: 4.5
    }, {
      name: 'Tudor L.',
      avatar: 'https://i.pravatar.cc/150?img=15',
      slug: 'andrei-popescu',
      occupation: 'Project Manager',
      verified: false,
      rating: 4.2
    }],
    comboAllVerified: false
  },
  'combo-pair': {
    id: '10',
    slug: 'combo-pair',
    firstName: 'Sara',
    lastName: 'V.',
    birthYear: 1996,
    occupation: 'Designer',
    city: 'București',
    budgetMin: 600,
    budgetMax: 900,
    budgetCurrency: 'EUR',
    housingType: 'apartament_bloc',
    coupleStatus: 'singur',
    isSmoker: false,
    hasPets: true,
    petDetails: '1 pisică',
    profilePhoto: 'https://i.pravatar.cc/150?img=47',
    profileViews: 88,
    verifications: {
      email: true,
      identity: true,
      income: true
    },
    rating: 4.7,
    neighborhoods: 'Cotroceni, Centru',
    moveInDate: 'Iulie, 2026',
    contractDuration: '2 ani',
    rooms: '3 cam',
    floor: 'Etaj 2-5',
    yearBuiltLabel: '> 2000',
    profileStatus: 'active',
    amenities: ['Parcare', 'Mobilat complet', 'Balcon / Terasă', 'Lift'],
    bio: 'Suntem trei prieteni care căutăm un apartament de 3 camere în Cotroceni. Ne place liniștea, gătim acasă des și avem o pisică.',
    reviews: [],
    rentalHistory: [],
    comboMembers: [{
      name: 'Sara V.',
      avatar: 'https://i.pravatar.cc/150?img=47',
      slug: 'combo-pair',
      occupation: 'Designer',
      verified: true,
      rating: 4.7
    }, {
      name: 'Tudor L.',
      avatar: 'https://i.pravatar.cc/150?img=15',
      slug: 'andrei-popescu',
      occupation: 'Project Manager',
      verified: true,
      rating: 4.6
    }, {
      name: 'Bianca R.',
      avatar: 'https://i.pravatar.cc/150?img=44',
      slug: 'maria-ionescu',
      occupation: 'Marketing Manager',
      verified: true,
      rating: 4.9
    }],
    comboAllVerified: true
  },
  'combo-grup': {
    id: '11',
    slug: 'combo-grup',
    firstName: 'Cristian',
    lastName: 'D.',
    birthYear: 1994,
    occupation: 'Marketing',
    city: 'București',
    budgetMin: 1000,
    budgetMax: 1400,
    budgetCurrency: 'EUR',
    housingType: 'apartament_bloc',
    coupleStatus: 'singur',
    isSmoker: false,
    hasPets: false,
    petDetails: '',
    profilePhoto: 'https://i.pravatar.cc/150?img=33',
    profileViews: 120,
    verifications: {
      email: true,
      identity: true,
      income: true
    },
    rating: 4.6,
    neighborhoods: 'Floreasca, Aviației',
    moveInDate: 'Septembrie, 2026',
    contractDuration: '1 an',
    rooms: '4 cam',
    floor: 'Etaj 1-5',
    yearBuiltLabel: '> 2010',
    profileStatus: 'active',
    amenities: ['Parcare', 'Mobilat complet', 'Balcon / Terasă', 'Lift', 'Aer condiționat'],
    bio: 'Suntem un grup de patru prieteni care căutăm o casă mare în zona Floreasca. Toți lucrăm în corporate, suntem ordonați și ne place să stăm acasă weekend-urile.',
    reviews: [],
    rentalHistory: [],
    comboMembers: [{
      name: 'Cristian D.',
      avatar: 'https://i.pravatar.cc/150?img=33',
      slug: 'combo-grup',
      occupation: 'Marketing',
      verified: true,
      rating: 4.6
    }, {
      name: 'Maria P.',
      avatar: 'https://i.pravatar.cc/150?img=48',
      slug: 'maria-ionescu',
      occupation: 'PR Manager',
      verified: true,
      rating: 4.8
    }, {
      name: 'Vlad T.',
      avatar: 'https://i.pravatar.cc/150?img=51',
      slug: 'mihai-constantinescu',
      occupation: 'Account Executive',
      verified: false,
      rating: 4.3
    }, {
      name: 'Andrei B.',
      avatar: 'https://i.pravatar.cc/150?img=53',
      slug: 'andrei-popescu',
      occupation: 'Sales Manager',
      verified: false
    }],
    comboAllVerified: false
  }
};
const DEFAULT_SLUG = 'olivia-p';
type MemberLite = {
  name: string;
  avatar?: string;
  slug?: string;
  occupation?: string;
  verified?: boolean;
  rating?: number;
};
function MemberListPanel({
  isOpen,
  onClose,
  members,
  onSelect
}: {
  isOpen: boolean;
  onClose: () => void;
  members: MemberLite[];
  onSelect: (m: MemberLite) => void;
}) {
  useEffect(() => {
    if (!isOpen) return;
    const original = document.body.style.overflow;
    document.body.style.overflow = 'hidden';
    return () => {
      document.body.style.overflow = original;
    };
  }, [isOpen]);
  if (!isOpen) return null;
  return <div className="fixed inset-0 z-50 flex items-end sm:items-center justify-center" role="dialog" aria-modal="true" aria-label="Membrii grupului" data-id="element-4199">
      {/* Backdrop */}
      <div className="absolute inset-0 bg-dark-1/80 backdrop-blur-sm" onClick={onClose} aria-hidden="true" data-id="element-4200" />
      {/* Panel */}
      <div className="relative w-full sm:max-w-md bg-dark-2 border-t sm:border border-dark-4 sm:rounded-2xl rounded-t-2xl overflow-hidden shadow-2xl animate-in slide-in-from-bottom-4 sm:slide-in-from-bottom-0 sm:fade-in duration-200" data-id="element-4201">
        <header className="flex items-center justify-between px-6 py-4 border-b border-dark-4" data-id="element-4202">
          <div data-id="element-4203">
            <h2 className="text-base font-semibold text-light-1" data-id="element-4204">
              Membrii grupului
            </h2>
            <p className="text-xs text-light-3 mt-0.5" data-id="element-4205">
              {members.length} {members.length === 1 ? 'persoană' : 'persoane'}{' '}
              · Apasă pentru profil
            </p>
          </div>
          <button onClick={onClose} className="text-light-3 hover:text-light-1 transition-colors p-1 -m-1 cursor-pointer rounded-sm outline-none focus-visible:ring-2 focus-visible:ring-lime-1" aria-label="Închide" data-id="element-4206">
            <X size={20} weight="bold" data-id="element-4207" />
          </button>
        </header>
        <ul className="divide-y divide-dark-4 max-h-[60vh] overflow-y-auto" data-id="element-4208">
          {members.map((m, idx) => <li key={`${m.slug || m.name}-${idx}`} data-id="element-4209">
              <button type="button" onClick={() => onSelect(m)} disabled={!m.slug} className={cn('w-full flex items-center gap-3 px-6 py-4 text-left transition-colors outline-none', m.slug ? 'hover:bg-dark-3 focus-visible:bg-dark-3 cursor-pointer' : 'cursor-default opacity-70')} data-id="element-4210">
                {m.avatar ? <img src={m.avatar} alt={m.name} className="w-10 h-10 rounded-full object-cover shrink-0" data-id="element-4211" /> : <div className="w-10 h-10 rounded-full bg-dark-3 flex items-center justify-center text-sm font-medium text-light-2 shrink-0" data-id="element-4212">
                    {m.name[0]}
                  </div>}
                <div className="min-w-0 flex-1" data-id="element-4213">
                  <div className="flex items-center gap-1.5" data-id="element-4214">
                    <span className="text-sm font-medium text-light-1 truncate" data-id="element-4215">
                      {m.name}
                    </span>
                    {m.verified && <SealCheck size={14} weight="fill" className="text-lime-1 shrink-0" aria-label="Profil verificat" data-id="element-4216" />}
                  </div>
                  <div className="flex items-center gap-1.5 text-xs text-light-3 mt-0.5" data-id="element-4217">
                    {m.occupation && <span className="truncate" data-id="element-4218">{m.occupation}</span>}
                    {typeof m.rating === 'number' && <>
                        {m.occupation && <span className="text-light-4" data-id="element-4219">·</span>}
                        <Star size={10} weight="fill" className="text-light-3 shrink-0" data-id="element-4220" />
                        <span data-id="element-4221">{m.rating.toFixed(1)}</span>
                      </>}
                  </div>
                </div>
                {m.slug && <CaretRight size={16} weight="bold" className="text-light-3 shrink-0" data-id="element-4222" />}
              </button>
            </li>)}
        </ul>
      </div>
    </div>;
}
export function TenantAnunt({
  navigate,
  context
}: TenantAnuntProps) {
  const slug = context?.slug || DEFAULT_SLUG;
  const profile = MOCK_PROFILES[slug] || MOCK_PROFILES[DEFAULT_SLUG];
  const viewerIsOwner = context?.viewerIsOwner === true;
  const isProfileInactive = profile.profileStatus === 'inactive';
  // Only treat the anunț as finalized when there's an ACTIVE succes offer
  // (no archiveSessionId). Past closures stay in Istoric anunțuri without
  // locking the current anunț as "mutat".
  const isTenantFinalized = getOffersForTenant(profile.slug).some(o => o.status === 'succes' && !o.archiveSessionId);
  const fullyVerified = isFullyVerified(profile.verifications);
  const [bookmarked, setBookmarked] = useState(() => isBookmarked(profile.slug));
  const [hasApplied, setHasApplied] = useState(() => hasAppliedTo(profile.slug));
  const [isMembersOpen, setIsMembersOpen] = useState(false);
  const [authGate, setAuthGate] = useState<{
    open: boolean;
    intent: AuthGateIntent;
  }>({
    open: false,
    intent: 'bookmark'
  });
  const session = getSession();
  const [isBookmarkedState, setIsBookmarkedState] = useState(false);
  const [isEditOfferOpen, setIsEditOfferOpen] = useState(false);
  // Check if applied using both old flag and new store
  const [hasAppliedState, setHasAppliedState] = useState(false);
  useEffect(() => {
    setIsBookmarkedState(isBookmarked(profile.slug));
    const applied = hasAppliedTo(profile.slug) || (session?.email ? hasOfferTo(session.email, profile.slug) : false);
    setHasAppliedState(applied);
  }, [profile.slug, session?.email]);
  // Build the wishlist payload passed to the unified PropertyWizard
  // when navigating to send an offer. Computed inline so we can reuse it
  // from both the auto-open effect and the explicit Trimite ofertă handler.
  const buildOfferWizardContext = () => {
    const locPills = [profile.rooms, profile.floor, profile.yearBuiltLabel].filter(Boolean) as string[];
    const wishlistLocations = [HOUSING_TYPES.find(t => t.value === profile.housingType)?.label || 'Apartament', ...locPills];
    return {
      mode: 'offer' as const,
      tenantProfileId: profile.slug,
      tenantName: profile.firstName,
      tenantWishlist: {
        locations: wishlistLocations,
        essentials: (profile.amenities || []) as string[],
        preferred: [] as string[]
      }
    };
  };
  // Auto-navigate into the offer wizard when returning from the auth flow
  // with an explicit "send_offer" intent. Only fires once, and only when the
  // viewer is now authenticated and hasn't already applied.
  useEffect(() => {
    if (!context?.openApplyModal) return;
    if (!session) return;
    if (viewerIsOwner) return;
    if (hasAppliedState) return;
    navigate(PAGE_ROUTE.PROPERTY_EDITOR, buildOfferWizardContext());
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [context?.openApplyModal, session?.email, hasAppliedState]);
  const handleBookmark = () => {
    if (!session) {
      setAuthGate({
        open: true,
        intent: 'bookmark'
      });
      return;
    }
    const nowSaved = toggleBookmark({
      slug: profile.slug,
      firstName: profile.firstName,
      lastName: profile.lastName,
      occupation: profile.occupation,
      city: profile.city,
      neighborhoods: profile.neighborhoods,
      profilePhoto: profile.profilePhoto,
      isVerified: isFullyVerified(profile.verifications),
      budgetMin: profile.budgetMin,
      budgetMax: profile.budgetMax,
      budgetCurrency: profile.budgetCurrency,
      status: profile.profileStatus
    });
    setIsBookmarkedState(nowSaved);
  };
  const handleSendOffer = () => {
    if (isTenantFinalized) return;
    if (!session) {
      setAuthGate({
        open: true,
        intent: 'offer'
      });
      return;
    }
    if (hasAppliedState) {
      setIsEditOfferOpen(true);
      return;
    }
    navigate(PAGE_ROUTE.PROPERTY_EDITOR, buildOfferWizardContext());
  };
  const handleMemberSelect = (m: MemberLite) => {
    if (!m.slug) return;
    setIsMembersOpen(false);
    navigate(PAGE_ROUTE.TENANT_PROFILE, {
      slug: m.slug
    });
  };
  const housingLabel = HOUSING_TYPES.find(t => t.value === profile.housingType)?.label || 'Apartament';
  const livingModeKey = profile.coupleStatus === 'singur' ? 'single' : profile.coupleStatus === 'cuplu' ? 'couple' : profile.coupleStatus === 'familie' ? 'family' : profile.coupleStatus === 'co-living' ? 'combo' : null;
  const livingModeDisplay = livingModeKey ? LIVING_MODE_DISPLAY[livingModeKey as LivingModeValue] : profile.coupleStatus;
  const composition = [livingModeDisplay, profile.isSmoker ? 'Fumător' : 'Nefumători', profile.hasPets ? profile.petDetails || 'Animale' : null].filter(Boolean).join(' · ');
  const handleProfileClick = () => {
    navigate(PAGE_ROUTE.TENANT_PROFILE, {
      slug: profile.slug
    });
  };
  const locationPills = [profile.rooms, profile.floor, profile.yearBuiltLabel].filter(Boolean) as string[];
  // ── Group state ─────────────────────────────────────────────────────
  const memberCount = profile.comboMembers?.length || 0;
  const isGroup = memberCount >= 2;
  const groupLabel = isGroup ? comboGroupLabel(memberCount) : null;
  const showVerified = isGroup ? !!profile.comboAllVerified : fullyVerified;
  const showComposition = !isGroup || profile.hasPets;
  return <>
      <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8 py-12 pb-32 sm:pb-12" data-id="element-4223">
        {viewerIsOwner && <div className="mb-6 rounded-2xl bg-lime-5 border border-lime-4 p-4 flex items-center gap-3" data-id="element-4224">
            <div className="w-2 h-2 rounded-full bg-lime-1 shrink-0" data-id="element-4225" />
            <p className="text-sm text-light-1 flex-1 min-w-0" data-id="element-4226">
              <span className="font-semibold" data-id="element-4227">
                Aceasta e vederea publică a anunțului tău.
              </span>{' '}
              <span className="text-light-3" data-id="element-4228">
                Așa te văd proprietarii în Marketplace.
              </span>
            </p>
            <button onClick={() => navigate(PAGE_ROUTE.DASHBOARD_ANUNT)} className="text-xs font-semibold text-lime-1 hover:text-lime-2 cursor-pointer shrink-0" data-id="element-4229">
              Editează anunțul
            </button>
          </div>}

        {isTenantFinalized && !viewerIsOwner && <div className="mb-6 rounded-2xl bg-lime-5 border border-lime-4 p-4 flex items-start gap-3" data-id="element-4230">
            <div className="w-2 h-2 rounded-full bg-lime-1 mt-1.5 shrink-0" data-id="element-4231" />
            <p className="text-sm text-light-2 flex-1" data-id="element-4232">
              <span className="font-semibold text-light-1" data-id="element-4233">
                Chiriașul s-a mutat. 🎉
              </span>{' '}
              Anunțul nu mai este activ — căutarea s-a încheiat cu succes.
            </p>
            <button onClick={() => navigate(PAGE_ROUTE.MARKETPLACE)} className="text-xs font-semibold text-lime-1 hover:text-lime-2 cursor-pointer shrink-0" data-id="element-4234">
              Vezi anunțuri similare
            </button>
          </div>}

        {isProfileInactive && !isTenantFinalized && !viewerIsOwner && <div className="mb-6 rounded-2xl bg-dark-2 border border-dark-4 p-4 flex items-start gap-3" data-id="element-4235">
            <div className="w-2 h-2 rounded-full bg-light-4 mt-1.5 shrink-0" data-id="element-4236" />
            <p className="text-sm text-light-2 flex-1" data-id="element-4237">
              <span className="font-semibold text-light-1" data-id="element-4238">
                Acest anunț e inactiv momentan.
              </span>{' '}
              Proprietarul l-a pus pe pauză.
            </p>
            <button onClick={() => navigate(PAGE_ROUTE.MARKETPLACE)} className="text-xs font-semibold text-lime-1 hover:text-lime-2 cursor-pointer shrink-0" data-id="element-4239">
              Vezi anunțuri similare
            </button>
          </div>}

        {!viewerIsOwner && <button onClick={() => navigate(PAGE_ROUTE.MARKETPLACE)} className="text-sm text-light-3 hover:text-light-1 transition-colors mb-6 inline-flex items-center gap-1.5 font-medium" data-id="element-4240">
            <ArrowLeft size={16} weight="bold" data-id="element-4241" />
            Înapoi la Marketplace
          </button>}

        {/* SINGLE CARD ANUNȚ */}
        <article className="rounded-2xl border border-dark-4 overflow-hidden bg-dark-2" data-id="element-4242">
          {/* Header section — items-center keeps the avatar (or stack)
           balanced with the name + sub-line block; bookmark uses
           self-start to stay top-pinned. */}
          <header className="bg-dark-1 px-6 py-6 flex items-center gap-4" data-id="element-4243">
            {isGroup ? <AvatarStack members={profile.comboMembers} size="lg" onClick={() => setIsMembersOpen(true)} ariaLabel={`Deschide lista membrilor grupului · ${memberCount} persoane`} data-id="element-4244" /> : <button onClick={handleProfileClick} className="shrink-0 outline-none focus-visible:ring-2 focus-visible:ring-lime-1 rounded-full" data-id="element-4245">
                {profile.profilePhoto ? <img src={profile.profilePhoto} alt={`${profile.firstName} ${profile.lastName}`} className="w-12 h-12 rounded-full object-cover" data-id="element-4246" /> : <div className="w-12 h-12 rounded-full bg-dark-3 flex items-center justify-center text-base font-medium text-light-2" data-id="element-4247">
                    {profile.firstName[0]}
                  </div>}
              </button>}

            <div className="min-w-0 flex-1" data-id="element-4248">
              <div className="flex items-center gap-1.5" data-id="element-4249">
                <button onClick={handleProfileClick} className="text-xl font-normal text-light-1 truncate leading-tight hover:underline outline-none focus-visible:ring-2 focus-visible:ring-lime-1 rounded-sm" data-id="element-4250">
                  {profile.firstName} {profile.lastName}
                </button>
                {showVerified && <SealCheck size={18} weight="fill" className="text-lime-1 shrink-0" aria-label={isGroup ? 'Toți membrii grupului sunt verificați' : 'Profil verificat complet'} data-id="element-4251" />}
              </div>
              <button onClick={handleProfileClick} className="flex items-center gap-1.5 text-sm font-normal text-light-3 mt-1 hover:text-light-2 transition-colors outline-none focus-visible:ring-2 focus-visible:ring-lime-1 rounded-sm" data-id="element-4252">
                {isGroup && <Users size={14} weight="fill" className="text-light-3 shrink-0" aria-hidden="true" data-id="element-4253" />}
                <span className="truncate" data-id="element-4254">
                  {groupLabel || profile.occupation}
                </span>
                {!isGroup && <>
                    <span className="text-light-4" data-id="element-4255">·</span>
                    <Star size={12} weight="fill" className="text-light-3 shrink-0" data-id="element-4256" />
                    <span data-id="element-4257">{profile.rating.toFixed(1)}</span>
                  </>}
              </button>
            </div>

            <button type="button" onClick={handleBookmark} className="text-light-3 hover:text-light-1 transition-colors p-1 -m-1 cursor-pointer shrink-0 self-start outline-none focus-visible:ring-2 focus-visible:ring-lime-1 rounded-sm" aria-label={bookmarked ? 'Elimină din salvate' : 'Salvează'} data-id="element-4258">
              <BookmarkSimple size={22} weight={bookmarked ? 'fill' : 'regular'} className={bookmarked ? 'text-lime-1' : ''} data-id="element-4259" />
            </button>
          </header>

          {/* Content section */}
          <div className="px-6 py-8 space-y-8" data-id="element-4260">
            <span className="inline-flex items-center bg-dark-3 px-2.5 py-1 rounded-full text-xs font-medium text-light-3 uppercase tracking-wider" data-id="element-4261">
              Postat acum 3 zile
            </span>

            <ul className="space-y-4 text-sm font-normal text-light-2" data-id="element-4262">
              <li className="flex items-center gap-3" data-id="element-4263">
                <Wallet size={20} weight="regular" className="text-light-2 shrink-0" data-id="element-4264" />
                <span className="text-base font-medium text-light-1" data-id="element-4265">
                  {formatBudget(profile.budgetMax)}{' '}
                  <span className="text-sm font-normal text-light-3" data-id="element-4266">
                    / lună
                  </span>
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-4267">
                <MapPin size={20} weight="regular" className="text-light-2 shrink-0" data-id="element-4268" />
                <span className="text-base" data-id="element-4269">
                  {profile.neighborhoods}{' '}
                  <span className="text-light-4" data-id="element-4270">· {profile.city}</span>
                </span>
              </li>
              <li className="flex items-center gap-3" data-id="element-4271">
                <Flag size={20} weight="regular" className="text-light-2 shrink-0" data-id="element-4272" />
                <span className="text-base" data-id="element-4273">
                  {profile.moveInDate} <span className="text-light-4" data-id="element-4274">·</span>{' '}
                  {profile.contractDuration}
                </span>
              </li>
              {showComposition && <li className="flex items-center gap-3" data-id="element-4275">
                  <Article size={20} weight="regular" className="text-light-2 shrink-0" data-id="element-4276" />
                  <span className="text-base" data-id="element-4277">{composition}</span>
                </li>}
            </ul>

            {/* Despre loc */}
            <div data-id="element-4278">
              <h2 className="text-xs font-medium text-light-3 uppercase tracking-wider mb-4" data-id="element-4279">
                Despre loc
              </h2>
              <div className="flex flex-wrap gap-2" data-id="element-4280">
                <span className="inline-flex items-center h-10 px-4 rounded-full text-sm font-normal bg-dark-4 text-light-1 border border-dark-4" data-id="element-4281">
                  {housingLabel}
                </span>
                {locationPills.map(pill => <span key={pill} className="inline-flex items-center h-10 px-4 rounded-full text-sm font-normal border border-dark-4 text-light-2" data-id="element-4282">
                    {pill}
                  </span>)}
              </div>
            </div>

            {/* Facilități dorite */}
            {profile.amenities && profile.amenities.length > 0 && <div data-id="element-4283">
                <h2 className="text-xs font-medium text-light-3 uppercase tracking-wider mb-4" data-id="element-4284">
                  Facilități dorite
                </h2>
                <div className="flex flex-wrap gap-2" data-id="element-4285">
                  {profile.amenities.map((a: string) => <span key={a} className="inline-flex items-center h-10 px-4 rounded-full text-sm font-normal border border-dark-4 text-light-2" data-id="element-4286">
                      {a}
                    </span>)}
                </div>
              </div>}

            {/* Ce caut bio */}
            {profile.bio && <div data-id="element-4287">
                <p className="text-sm font-normal text-light-2 leading-relaxed" data-id="element-4288">
                  {profile.bio}
                </p>
              </div>}

            {/* Apply CTA — desktop inline */}
            <div className="hidden sm:block pt-4" data-id="element-4289">
              <button onClick={handleSendOffer} disabled={isTenantFinalized} className={cn('w-full font-semibold h-12 rounded-md inline-flex items-center justify-center gap-2 transition-colors', isTenantFinalized ? 'bg-dark-3 text-light-4 cursor-not-allowed border border-dark-4' : hasAppliedState ? 'bg-dark-3 hover:bg-dark-4 text-light-1 border border-dark-4' : 'bg-lime-1 hover:bg-lime-2 text-dark-1')} data-id="element-4290">
                {isTenantFinalized ? <>Anunț închis — Închiriat</> : hasAppliedState ? <>
                    <Check size={18} weight="bold" className="text-lime-1" data-id="element-4291" />
                    Ofertă trimisă · Editează
                  </> : <>
                    <PaperPlaneTilt size={18} weight="fill" data-id="element-4292" />
                    Trimite ofertă
                  </>}
              </button>
            </div>
          </div>
        </article>
      </div>

      {/* Mobile sticky-bottom CTA */}
      <div className="sm:hidden fixed bottom-0 left-0 right-0 z-30 px-4 py-3 bg-dark-1/90 backdrop-blur border-t border-dark-4" data-id="element-4293">
        <button onClick={handleSendOffer} disabled={isTenantFinalized} className={cn('w-full font-semibold h-12 rounded-md inline-flex items-center justify-center gap-2 transition-colors', isTenantFinalized ? 'bg-dark-3 text-light-4 cursor-not-allowed border border-dark-4' : hasAppliedState ? 'bg-dark-3 hover:bg-dark-4 text-light-1 border border-dark-4' : 'bg-lime-1 hover:bg-lime-2 text-dark-1')} data-id="element-4294">
          {isTenantFinalized ? <>Anunț închis — Închiriat</> : hasAppliedState ? <>
              <Check size={18} weight="bold" className="text-lime-1" data-id="element-4295" />
              Ofertă trimisă · Editează
            </> : <>
              <PaperPlaneTilt size={18} weight="fill" data-id="element-4296" />
              Trimite ofertă
            </>}
        </button>
      </div>

      {/* Edit Offer Modal */}
      <OfferEditModal isOpen={isEditOfferOpen} onClose={() => setIsEditOfferOpen(false)} mode="edit" tenantName={profile.firstName} tenantProfileId={profile.slug} onSuccess={() => setIsEditOfferOpen(false)} navigate={navigate} data-id="element-4297" />

      {/* Member list panel — group listings only */}
      <MemberListPanel isOpen={isMembersOpen} onClose={() => setIsMembersOpen(false)} members={profile.comboMembers || []} onSelect={handleMemberSelect} data-id="element-4298" />

      {/* Auth gate modal */}
      <AuthGateModal isOpen={authGate.open} onClose={() => setAuthGate(s => ({
      ...s,
      open: false
    }))} intent={authGate.intent} navigate={navigate} tenantSlug={profile.slug} data-id="element-4299" />
    </>;
}